module.exports = __webpack_public_path__ + "static/media/th-start__thief.e849e0c1.svg";